export default __webpack_public_path__ + "static/sublime-7d6019f89e1133fee637a2f8ab76a723.webp";